import { useState, useEffect } from 'react';
import { navLinks, siteInfo } from '@/mocks/homeData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px] max-w-[1400px] mx-auto">
          <a href="#hero" className="flex items-center gap-2 whitespace-nowrap cursor-pointer" onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}>
            <span className="text-xl md:text-2xl font-display text-primary-500 tracking-wide">
              {siteInfo.siteName}
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-md hover:bg-primary-50 whitespace-nowrap cursor-pointer"
              >
                {link.text}
              </a>
            ))}
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {link.text}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}